module.exports = __webpack_public_path__ + "assets/img/block-right-hover-719208b3.png";